import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  nestedProduct: {
    transition: '0.2s',

    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.white.main,
      cursor: 'pointer',
      transition: '0.2s',
    },
  },

}));

export default useStyles;
